import React from 'react';
import { CONFIG } from 'config/config';
import { isMobile } from 'react-device-detect';
import { Button, Text, View } from '@coinscrap/webapp-core';
import TextSpan from '../TextSpan/TextSpan';
import pencil from '../../assets/images/svgStatic/pencil.svg';
import square from '../../assets/images/svgStatic/square-x.svg';

import * as S from './styles';

const BeneficiaryBox = ({ ben, onDelete, onEdit }) => {
	return (
		<S.PrimaryWrapper>
			<View style={{ width: 'min-content', flexGrow: 1 }}>
				<S.QuestionnaireBoxWrapper isMobile={isMobile}>
					<Text benefKeySt>
						Nombre:
						<TextSpan
							style={{
								fontFamily: CONFIG.fonts.light,
								color: CONFIG.colors.primary,
								marginLeft: 10,
							}}
						>
							{ben.name || ''}
						</TextSpan>
					</Text>
					<Text benefKeySt>
						Apellidos:
						<TextSpan
							style={{
								fontFamily: CONFIG.fonts.light,
								color: CONFIG.colors.primary,
								marginLeft: 5,
							}}
						>
							{ben.surname || ''}
						</TextSpan>
					</Text>
					<Text benefKeySt>
						Documento:
						<TextSpan
							style={{
								fontFamily: CONFIG.fonts.light,
								color: CONFIG.colors.primary,
								marginLeft: 10,
							}}
						>
							{ben.dni || ''}
						</TextSpan>
					</Text>
					<Text benefKeySt>
						Porcentaje:
						<TextSpan
							style={{
								fontFamily: CONFIG.fonts.light,
								color: CONFIG.colors.primary,
								marginLeft: 10,
							}}
						>
							{`${ben.percentage} %` || ''}
						</TextSpan>
					</Text>
				</S.QuestionnaireBoxWrapper>
			</View>
			<S.QuestionnaireBoxButtonWrapper>
				<Button beneficiaryCircleOptionSt onClick={onEdit} style={{ minWidth: 0 }}>
					<img
						src={pencil}
						alt="Edit Icon"
						style={{ color: CONFIG.colors.primary, width: '24px', height: '24px' }}
					/>
				</Button>
				<Button beneficiaryCircleOptionSt onClick={onDelete} style={{ minWidth: 0 }}>
					<img
						src={square}
						alt="Delete Icon"
						style={{ color: CONFIG.colors.primary, width: '24px', height: '24px' }}
					/>
				</Button>
			</S.QuestionnaireBoxButtonWrapper>
		</S.PrimaryWrapper>
	);
};

export default BeneficiaryBox;
